import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { appConfigs, toAbsoluteUrl } from "../../_helpers";

export function PageTitle({ heading = '', headingMeta = '', back = '', meta = {} }) {
    const navigate = useNavigate();
    useEffect(() => {
        document.title = heading + " — " + appConfigs.app_name;
        // meta fixes
        try {
            if (Object.keys(meta).length > 0) {
                if (meta?.description) document.querySelector('meta[name="description"]').setAttribute("content", meta?.description);
                if (meta?.description) document.querySelector('meta[property="og:description"]').setAttribute("content", meta?.description);
                if (meta?.description) document.querySelector('meta[name="twitter:description"]').setAttribute("content", meta?.description);
                document.querySelector('meta[property="og:title"]').setAttribute("content", document.title);
                document.querySelector('meta[name="twitter:title"]').setAttribute("content", document.title);
                if (meta?.image) document.querySelector('meta[property="og:image"]').setAttribute("content", meta?.image);
                if (meta?.image) document.querySelector('meta[name="twitter:image"]').setAttribute("content", meta?.image);
            } else {
                if (meta?.description) document.querySelector('meta[name="description"]').setAttribute("content", "Hello, I'm Martin. I have been working professionally as a front-end developer for a long time now, and I'm currently working full time as a senior front-end developer at Azenia.");
                if (meta?.description) document.querySelector('meta[property="og:description"]').setAttribute("content", "Hello, I'm Martin. I have been working professionally as a front-end developer for a long time now, and I'm currently working full time as a senior front-end developer at Azenia.");
                if (meta?.description) document.querySelector('meta[name="twitter:description"]').setAttribute("content", "Hello, I'm Martin. I have been working professionally as a front-end developer for a long time now, and I'm currently working full time as a senior front-end developer at Azenia.");
                document.querySelector('meta[property="og:title"]').setAttribute("content", document.title);
                document.querySelector('meta[name="twitter:title"]').setAttribute("content", document.title);
                if (meta?.image) document.querySelector('meta[property="og:image"]').setAttribute("content", toAbsoluteUrl('/_media/images/logo512.png'));
                if (meta?.image) document.querySelector('meta[name="twitter:image"]').setAttribute("content", toAbsoluteUrl('/_media/images/logo512.png'));
            }
        } catch (error) {

        }
    }, [heading, meta]);
    return (
        <>
            <div className="row">
                <div className="col-md-12 col-md-offset-3 col-md-pull-3">
                    {(headingMeta === '' && back !== '') && <span className="heading-meta"><span className="cursor-pointer" style={{ 'padding': '6px 0' }} onClick={() => navigate(back)}>&#10229; Back</span></span>}
                    {(headingMeta !== '' && back === '') && <span className="heading-meta">{headingMeta}</span>}
                    <h2 className="martin-heading">{heading}</h2>
                </div>
            </div>
        </>
    );
}
